import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { useProximidad } from '../../../hooks/useProximidad';
import { YsocialContext } from '../../../contexts/YsocialContext';
import { Direccion } from '../../../interfaces/direccion.interface';
import PageWrapper from '../../../components/PageWrapper/PageWrapper';
import { updateSocioPrincipal } from '../../../api/socioPrincipalService';
import { Button, Modal, TextLink } from 'app-principal-componentes-visuales';
import LocalidadError from '../../../components/Modals/LocalidadError/LocalidadError';
import { YsocialActionType } from '../../../interfaces/global-state/ysocial.action.type.enum';
import EliminarDomicilio from '../../../components/Modals/EliminarDomicilio/EliminarDomicilio';
import ProximidadUbicacion from '../../../components/Modals/ProximidadUbicacion/ProximidadUbicacion';
import { DATOS_CONTACTOS_YSOCIAL, FORMULARIO_DOMICILIO_YSOCIAL, SELECCIONAR_DIRECCION_YSOCIAL, FORMULARIO_BARRIO_CERRADO_YSOCIAL, RESUMEN_YSOCIAL } from '../../../utils/constants';
import ErrorPage from '../../ErrorPage/ErrorPage';
import DatosUbicacionYsocial from '../../../components/WebYsocial/Cards/DatosUbicacion/DatosUbicacionYsocial';
import TipoFormulario from '../../../components/Modals/TipoFormulario/TipoFormulario';
import { useDirecciones } from '../../../hooks/useDirecciones';
import './SeleccionarDomicilioYsocial.scss';

const SeleccionarDomicilioYsocial = () => {

    const history = useHistory();
    const { ysocial, useRequest, isWeb } = useContext(YsocialContext);
    const { apiRequest } = useRequest();
    const { usuario } = ysocial;
    const [showDeleteDirectionModal, setDeleteDirectionModal] = useState(false);
    const [selectedDirection, setSelectedDirection] = useState({});
    const [direccionesSocio, setDireccionesSocio] = useState(usuario.direcciones || []);
    const [modalDelete, setModalDelete] = useState('');
    const [selectedOption, setSelectedOption] = useState<Direccion>(null);
    const [showTipoFormularioModal, setShowTipoFormularioModal] = useState(false);

    const { error,
        localidadError,
        proximidadModal,
        direccionProxima,
        onClickContinuar,
        handleClickCambiarDireccionProximidad,
        handleClickValidarProximidad,
        setError,
        setLocalidadError,
        setProximidadModal } = useProximidad();

    const { updateDirection, foundSelected } = useDirecciones({ 
        socioPrincipal: usuario, 
        apiRequest, 
        direccionesSocio: usuario.direcciones, 
        isYsocial: true 
    });

    useEffect(() => {
        setDireccionesSocio(usuario.direcciones);
    }, [usuario.direcciones])

    useEffect(() => {
        let seleccionada = usuario.direcciones.find((direccion) => direccion.seleccionado === true);
        setSelectedOption(seleccionada);
    }, [])

    /**
     * Encargado de abrir/cerrar el modal del tipo de formulario
     */
    const handleAgregarNuevoDomicilio = (selectedDirection) => {
        setSelectedDirection(selectedDirection);
        setShowTipoFormularioModal(true);
    }

    /**
     * Encargado de abrir/cerrar el modal de eliminacion de direcciones
     */
    const openDeleteDirection = (selectedDirection, modal) => {
        setModalDelete(modal);
        setSelectedDirection(selectedDirection);
        setDeleteDirectionModal(!showDeleteDirectionModal);
    }

    /**
     * Metodo que elimina la direccion seleccionada del socio principal
     */
    const deleteDirection = (direccionId) => {
        let direccionSinSeleccionado = [];
        const direccionFiltrada = direccionesSocio.filter(direccion => {
            return direccionId !== direccion.id
        });

        if (direccionId === selectedOption.id && direccionFiltrada.length !== 0) {
            direccionSinSeleccionado = direccionFiltrada.map((direccion, index) => {
                if (index === direccionFiltrada.length - 1) {
                    let dirSelected = { ...direccion, seleccionado: true }
                    setSelectedOption(dirSelected);
                    return dirSelected
                }
                return direccion
            });
        }

        updateDirection(direccionSinSeleccionado.length > 0 ? direccionSinSeleccionado : direccionFiltrada);
        setDeleteDirectionModal(!showDeleteDirectionModal);
    }

    const returnSelectedDirection = (seleccionado) => {
        setSelectedOption(seleccionado);
    };

    const handleBack = async () => {
        history.push(DATOS_CONTACTOS_YSOCIAL);
    }



    if (error) {
        return <ErrorPage setError={setError} />
    }

    return (
        <>
            {direccionesSocio.length === 0 ?
                <PageWrapper
                    pageClassName='ysocial-direcciones'
                    path={SELECCIONAR_DIRECCION_YSOCIAL}
                    socio={ysocial.usuario}
                    handlerHandleBack={handleBack}
                    notCancel={false}
                >
                    <IonRow>
                        <IonCol size='12' className='sin-domicilio'>
                            <Button
                                className='button--ripple'
                                colorBlack
                                label="No tenés domicilios registrados"
                            />
                        </IonCol>
                        <IonCol size='12' className='direcciones__col--padding'>
                            <TextLink
                                onClick={handleAgregarNuevoDomicilio}
                                right
                                texto="Agregar un nuevo domicilio"
                                id="nuevo-domicilio"
                            />
                        </IonCol>
                    </IonRow>
                </PageWrapper>
                :
                <PageWrapper
                    pageClassName='asistencia-medica-direcciones'
                    path={SELECCIONAR_DIRECCION_YSOCIAL}
                    socio={ysocial.usuario}
                    handlerHandleBack={handleBack}
                    className='direcciones_container'
                    notCancel={true}
                    noPadding={true}
                >
                    <IonGrid>
                        <IonRow className='listado-direcciones__row'>
                            <IonCol size='12'>
                                <DatosUbicacionYsocial
                                    direcciones={direccionesSocio}
                                    openDeleteDirection={openDeleteDirection}
                                    returnSelectedDirection={returnSelectedDirection}
                                    setSelectedOption={setSelectedOption}
                                />
                                <TextLink
                                    className='direcciones_padding'
                                    onClick={handleAgregarNuevoDomicilio}
                                    right
                                    texto="Agregar un nuevo domicilio"
                                    id="nuevo-domicilio"
                                />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                    <IonRow className="sticky-button direcciones_padding" >
                        <Button
                            id="seleccionar-domicilio-continuar"
                            className='seleccionar-domicilio__button'
                            key="continue_button"
                            primary
                            onClick={() => handleClickValidarProximidad(selectedOption) }
                            label={"Continuar"}
                            disable={localidadError}
                        />
                    </IonRow>
                </PageWrapper>
            }

            <Modal
                className='modal_web'
                hideCloseBtn
                //@ts-ignore
                component={
                    <EliminarDomicilio 
                        openDeleteDirection={openDeleteDirection} 
                        selectedDirection={selectedDirection} 
                        deleteDirection={deleteDirection} 
                        modalDelete={modalDelete} 
                        isWeb={isWeb} 
                    />}
                setShowModal={setDeleteDirectionModal}
                showModal={showDeleteDirectionModal}
                id="eliminar-domicilio-modal"
            />


            <Modal
                screen60
                className="modal_web"
                component={
                    <ProximidadUbicacion
                        onClickContinuar={() => onClickContinuar(selectedOption)}
                        onClickCambiarDireccion={handleClickCambiarDireccionProximidad}
                        direccionMasProxima={direccionProxima}
                    />
                }
                setShowModal={setProximidadModal}
                showModal={proximidadModal}
                id="modal-proximidad-ubicacion"
            />

            <Modal
                screen60
                hideCloseBtn
                //@ts-ignore
                component={
                    <LocalidadError
                        setLocalidadError={setLocalidadError}
                    />
                }
                setShowModal={setLocalidadError}
                showModal={localidadError}
                id="modal-localidad-error"
            />

            <Modal
                className='modal_web'
                //@ts-ignore
                component={
                    <TipoFormulario
                        pathDomicilio={FORMULARIO_DOMICILIO_YSOCIAL}
                        pathBarrioCerrado={FORMULARIO_BARRIO_CERRADO_YSOCIAL}
                        propsDomicilio={{fromState: SELECCIONAR_DIRECCION_YSOCIAL, redirectTo: RESUMEN_YSOCIAL}}
                        propsBarrioCerrado={{fromState: SELECCIONAR_DIRECCION_YSOCIAL, redirectTo: RESUMEN_YSOCIAL}}
                    />
                }
                setShowModal={setShowTipoFormularioModal}
                showModal={showTipoFormularioModal}
                id="tipo-formulario-modal" 
            />
        </>
    )
}

export default SeleccionarDomicilioYsocial